import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import AddWorkForceLayer from "./AddWorkForceLayer";


const AddWorkForcePage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Add WorkForce" />

        {/* AddUserLayer */}
        <AddWorkForceLayer />


      </MasterLayout>
    </>
  );
};

export default AddWorkForcePage;
